module.exports = __webpack_public_path__ + "static/wildflowers-small-40717f1df98d30a3fce8848f66b394be.png";